<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" style="display: block; overflow-x: hidden; overflow-y: auto; background: rgba(1,1,1,0.5)" @click="fermer">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" @click.stop="">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ data.NomJeu }} <span class="badge badge-secondary">{{ data.CodeJeu }}</span></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="fermer">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img :src="data.Photo2" style="width: 100%">
                        <small v-if="data.NomCreateurJeu != ''" class="modal-subtitle">Un jeu de : {{ data.NomCreateurJeu }}</small>
                        <template v-if="data.DescriptionJeu != ''">
                            <p style="white-space: pre-wrap">{{ data.DescriptionJeu }}</p>
                            <p><i>− Description en provenance de l'&eacute;diteur.</i></p>
                        </template>
                        <template v-else>
                            <p style="white-space: pre-wrap"><i>Pas de description.</i></p>
                        </template>
                        <ul>
                        <li v-if="data.SiteWeb1 && data.SiteWeb1 != 'http://'"><a :href="data.SiteWeb1" class="card-link">Site officiel</a></li>
                        <li v-if="data.TrictracSlug"><a :href="'https://www.trictrac.net/jeu-de-societe/'+data.TrictracSlug" class="card-link" hreflang="fr">Fiche TricTrac&nbsp;</a></li>
                        <li v-if="data.BggBoardgame != 0"><a :href="'https://boardgamegeek.com/boardgame/'+data.BggBoardgame" class="card-link" hreflang="en">Fiche BoardGameGeek&nbsp;</a></li>
                        </ul>
                        <p>
                            type: <span class="badge badge-info">{{ data.TypeJeux }}</span><br>
                            cat&eacute;gorie: <span class="badge badge-info">{{ data.NomEmplacement }}</span><br>
                            disponibilit&eacute;: <span class="badge" :class="badge(data.StatutJeux_IdStatutJeux)">{{ data.StatutJeu }}</span>
                        </p>
                        <div class="d-flex justify-content-between align-items-center">
                            <span>
                                <template v-if="data.AgeMax === '99'"><i class="fas fa-child"></i> {{ data.AgeMin }}+ ans</template>
                                <template v-else-if="data.AgeMax === data.AgeMin"><i class="fas fa-child"></i> {{ data.AgeMin }} ans</template>
                                <template v-else><i class="fas fa-child"></i> {{ data.AgeMin }} - {{ data.AgeMax }} ans</template>
                            </span>
                            <span>
                                <template v-if="data.NbrJoueurMin === data.NbrJoueurMax"><i class="fas fa-users"></i> {{ data.NbrJoueurMin }} joueurs</template>
                                <template v-else><i class="fas fa-users"></i> {{ data.NbrJoueurMin }} - {{ data.NbrJoueurMax }} joueurs</template>
                            </span>
                            <span>
                                <template v-if="data.DureeMin === data.DureeMax"><i class="fas fa-clock"></i> {{ data.DureeMin | dureeAffichage }}</template>
                                <template v-else><i class="fas fa-clock"></i> {{ data.DureeMin | dureeAffichage }} - {{ data.DureeMax | dureeAffichage }}</template>
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="dropdown">
                            <button class="btn btn-primary dropdown-toggle" type="button" @click="reserverDropDown=!reserverDropDown">
                                <i class="fas fa-thumbtack"></i> R&eacute;server
                            </button>
                            <div class="dropdown-menu" :class="{show: reserverDropDown}">
                                <a class="dropdown-item" href="#" @click="reserver(2)">Savenay</a>
                            </div>
                        </div>
                        <button type="button" class="btn btn-dark" data-dismiss="modal" @click="fermer">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['idJeu'],
    data() {
        return {
            data: {},
            reserverDropDown: false
        }
    },
    watch: {
        idJeu(v) {
            if (v == 0) {
                return;
            }
            // console.log("watch: "+v);

            this.resource.details({IdJeux: v})
                .then(response => {
                    // console.log(response.body);
                    return response.json();
                })
                .then(res => {
                    this.data = res.Data[0];
                });
        }
    },
    methods: {
        fermer() {
            // this.reserverDropDown = false;
            this.$emit('fermer');
        },
        reserver(lieu) {
            // Vérifier si l'utilisateur est connecté sur wordpress
            this.resource.getCurrentUser().then(
                res => {
                    const userEmail = res.body;
                    if (userEmail != "") {
                        // Oui, poursuit
                        this.reserverAppel(lieu);
                    } else {
                        // Non, indique de se connecter
                        alert("Erreur\nVeuillez avant vous connecter au site avec votre adresse courriel.");
                    }
                },
                error => {
                    alert("Une erreur s'est produite:\n"+error)
                }
            )
        },
        reserverAppel(lieu) {
            const formData = {
                site: lieu,
                IdJeu: this.data.IdJeux
            }
            // console.log('reserver le jeu ', formData)
            this.resource.reserver({}, formData)
                .then(res => {
                    // console.log("resa OK", res.body);
                    if (res.body === "") {
                        alert("Votre réservation a bien été prise en compte.\nPour les réservations sur Savenay, un courriel sera envoyé lorsque le jeu sera mis de côté.");
                    } else {
                        alert(res.body.error);
                    }
                }, error => {
                    alert("Une erreur s'est produite:\n"+error);
                });
        },
        badge(IdStatutJeux) {
            switch (IdStatutJeux) {
                case '1': // Disponible
                    return 'badge-success';
                case '2': // Emprunt à valider
                    return 'badge-warning';
                case '3': // Emprunté
                    return 'badge-warning';
                case '7': // Réservé
                    return 'badge-warning';
                default:
                    return 'badge-danger';
            }
        }
    },
    created() {
        let customActions = {
            details: {
                method: 'GET',
                url: 'jeu/{IdJeux}'
            },
            reserver: {
                root: 'https://www.ludotheque-savenay.fr/ludopen_web/index.php/',
                method: 'POST',
                url: 'ctr_resa/ReserverJeu/',
                emulateJSON: true
            },
            getCurrentUser: {
                root: 'https://www.ludotheque-savenay.fr/',
                method: 'GET',
                url: 'get_current_user.php',
            }
        }
        this.resource = this.$resource('', {}, customActions, {emulateJSON: false});

        if (this.idJeu == 0) {
            return;
        }
        console.log("watch: "+this.idJeu);

        this.resource.details({IdJeux: this.idJeu})
            .then(response => {
                return response.json();
            })
            .then(res => {
                this.data = res.Data[0];
            });
    }
}
</script>

<style scoped>
a[hreflang $= "fr"]:after {
    /*background: url("/static/fr.svg");*/
    background: url("https://www.ludotheque-savenay.fr/ludopen_web/demo/static/fr.svg");
    background-repeat: no-repeat;
    padding: 0 0 0 25px;
    content: ""
}
a[hreflang $= "en"]:after {
    /*background: url("/static/gb.svg");*/
    background: url("https://www.ludotheque-savenay.fr/ludopen_web/demo/static/gb.svg");
    background-repeat: no-repeat;
    padding: 0 0 0 25px;
    content: ""
}
/*
    Override conflict from stylesheet ludopen_web-style-css
*/
.btn, .dropdown-menu, small {
    font-size: inherit;
}
.close{
    font-size: 21px;
}
h5 {
    font-size: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/jeuxdetails.vue